function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import LandingPageBG from './landingpage/LandingPageBG.react';
import Tour from './landingpage/Tour.react';
import Overview from './landingpage/Overview.react';
import Hydrotip from './landingpage/Hydrotip.react';
var LandingPage = function LandingPage() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    bgLoaded = _useState2[0],
    setBgLoaded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 1),
    tLoaded = _useState6[0];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    tLogo = _useState8[0],
    setTLogo = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    tMore = _useState0[0],
    setTMore = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    tIntroducing = _useState10[0],
    setTIntroducing = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    tTour = _useState12[0],
    setTTour = _useState12[1];
  var clearTimers = function clearTimers() {
    if (tLogo) clearTimeout(tLogo);
    if (tMore) clearTimeout(tMore);
    if (tIntroducing) clearTimeout(tIntroducing);
    if (tTour) clearTimeout(tTour);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    var img = new window.Image();
    img.onload = function () {
      var img = new window.Image();
      img.onload = function () {
        var img = new window.Image();
        img.onload = function () {
          var img = new window.Image();
          img.onload = function () {
            $('.purpose__loader').css({
              opacity: 0
            });
            if (tLoaded) clearTimeout(tLoaded);
            setLoaded(true);
          };
          img.src = '/public/images/landingpage/video-copy.png';
        };
        img.src = '/public/images/landingpage/homepage-subhead@3x.png';
      };
      img.src = '/public/images/landingpage/learn-more@3x.png';
    };
    img.src = '/public/images/landingpage/wash-plant-logo-homepage-blue@3x.png';
  }, [bgLoaded]);
  useEffect(function () {
    setTIntroducing(setTimeout(function () {
      $('.landingpage__introducing').addClass('landingpage__introducing--active');
    }, 200));
    setTLogo(setTimeout(function () {
      $('.landingpage__logo').addClass('landingpage__logo--active');
    }, 500));
    setTMore(setTimeout(function () {
      $('.landingpage__learn').addClass('landingpage__learn--active');
    }, 2000));
    setTTour(setTimeout(function () {
      $('.landingpage__tour').addClass('landingpage__tour--active');
    }, 2000));
    setTTour(setTimeout(function () {
      $('.landingpage__overview').addClass('landingpage__overview--active');
    }, 2000));
    setTTour(setTimeout(function () {
      $('.landingpage__hydrotip').addClass('landingpage__hydrotip--active');
    }, 2000));

    // setTTour(setTimeout(() => {
    // 	$('.landingpage__operation').addClass('landingpage__operation--active');
    // }, 2000));
  }, [loaded]);
  return /*#__PURE__*/React.createElement("div", {
    className: "landingpage"
  }, /*#__PURE__*/React.createElement("div", {
    className: "landingpage-logo"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.posillicomaterials.com/proof",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof.png"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof-ro.png",
    className: "ro"
  }))), /*#__PURE__*/React.createElement(LandingPageBG, {
    onLoaded: function onLoaded() {
      return setBgLoaded(true);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "landingpage__overlay"
  }), loaded && /*#__PURE__*/React.createElement("div", {
    className: "aspectratio"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/wash-plant-logo-homepage-blue@3x.png",
    className: "landingpage__logo"
  }), /*#__PURE__*/React.createElement(NavLink, {
    to: "/our-purpose"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/learn-more@3x.png",
    className: "landingpage__learn"
  })), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/homepage-subhead@3x.png",
    className: "landingpage__introducing"
  }), /*#__PURE__*/React.createElement("div", {
    className: "landingpage__video"
  }, /*#__PURE__*/React.createElement(Tour, null), /*#__PURE__*/React.createElement(Overview, null), /*#__PURE__*/React.createElement(Hydrotip, null))));
};
export default LandingPage;